export default __webpack_public_path__ + "static/media/company_logo.fdfc947b.png";